import {
    TemplateCard,
    type TemplateCardProps,
} from "@backstage/plugin-scaffolder-react/alpha";

const DEPRECATED_LIFECYCLE = "deprecated";
const DEPRECATED_PREFIX = "⛔ DEPRECATED\n\n";
const DEPRECATED_TITLE_PREFIX = "⛔ ";

export function DeprecatedAwareTemplateCard(props: TemplateCardProps) {
    const { template, onSelected, ...rest } = props;
    const handleSelected = onSelected ? () => onSelected(template) : undefined;
    if (template.spec.lifecycle === DEPRECATED_LIFECYCLE) {
        const { title, name, description } = template.metadata;
        const patched = {
            ...template,
            metadata: {
                ...template.metadata,
                title: DEPRECATED_TITLE_PREFIX + (title ?? name),
                description: DEPRECATED_PREFIX + (description ?? ""),
            },
        };
        return (
            <TemplateCard
                {...rest}
                template={patched}
                onSelected={handleSelected}
            />
        );
    }
    return (
        <TemplateCard
            {...rest}
            template={template}
            onSelected={handleSelected}
        />
    );
}
